<template>
 <div>
  <map-info-modal ref="mapInfoModalRef">
   <label slot="title">添加自定义信息点</label>
   <div slot="content">
    <div>
     <label>地址：</label><label>{{content.addr}}</label>
    </div>
    <div style="margin-top: 3px;">
     <label>经度：{{content.longitude}}</label><label style="margin-left: 10px;">纬度：{{content.latitude}}</label>
    </div>
    <div style="margin-top: 3px;">
     <label>名称：</label><Input size="small" v-model="content.name"
                              style="width: 180px;"></Input>
    </div>
    <div style="margin-top: 3px;">
     <label>备注：</label><Input size="small" v-model="content.remark" style="width: 180px;"
                              type="textarea"></Input>
    </div>
    <div style="margin-top: 3px; text-align: right; margin-right: 10px;">
     <Button size="small" @click="onSave">保存</Button>
    </div>
   </div>
  </map-info-modal>
 </div>
</template>
<script>

  import store from '@/store'

  import {GPS} from '@/libs/positonUtils'
  import {reqReverseGeocoder} from '@/libs//baidumaputil'

  import MapInfoModal from '@/view/ddm/components/map-info-windows/map-info-modal'

  export default {
    name: 'addcustomerpointmodal',
    components: {
      MapInfoModal
    },
    props: {},
    data() {
      return {
        mapInfoModalRef:null,
        content: {
          addr: null,
          latitude: null,
          longitude: null,
          name: null,
          remark: null
        }
      }
    },
    methods: {
      onSave(){
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认添加自定义点</p>',
          onOk: () => {
            store.dispatch('CustomPOIServ_AddObj', {
              params: this.content,
              urlparams: null
            }).then(() => {
              this.$Message.success('添加成功')
              // console.log(store.getters.get_CustomPOI_AddObjResult)
              this.$emit('on-add', store.getters.get_CustomPOI_AddObjResult.id)
              this.onClose()
            }).catch(err => {
              this.$Message.error(err)
            })
          },
          onCancel: () => {
          }
        })
      },
      onMapPan(delta) {
        this.mapInfoModalRef.onMapPan(delta)
      },
      onMapPanEnd(delta) {
        this.mapInfoModalRef.onMapPanEnd(delta)
      },
      onMapZoom() {
        this.mapInfoModalRef.onMapZoom()
      },
      onMapZoomEnd() {
        this.mapInfoModalRef.onMapZoomEnd()
      },
      onClose() {
        this.mapInfoModalRef.onClose()
        this.content.addr = null
        this.content.latitude = null
        this.content.longitude = null
        this.content.name = null
        this.content.remark = null
      },
      moveModalByDelta(deltaScreenX, deltaScreenY) {
        this.mapInfoModalRef.moveModalByDelta(deltaScreenX, deltaScreenY)
      },
      moveModal(screenX, screenY) {
        this.mapInfoModalRef.moveModal(screenX, screenY)
      },
      moveModalByWebPoint(webPoint){
        this.mapInfoModalRef.moveModalByWebPoint(webPoint)
      },
      showModalByLatLng(map, arcgisModules, wgs84Lng, wgs84Lat) {
        this.mapInfoModalRef.showModalByLatLng(map, arcgisModules, wgs84Lng, wgs84Lat)
      },
      showModal(map, arcgisModules, webX, webY) {
        this.mapInfoModalRef.showModal(map, arcgisModules, webX, webY)
        let level = map.getLevel()
        let pres = Math.min(6, level)
        let v = arcgisModules.webMercatorUtils.xyToLngLat(webX.toFixed(pres), webY.toFixed(pres))
        let pos = GPS.gcj_decrypt(v[1], v[0])
        this.content.longitude = pos.lon
        this.content.latitude = pos.lat
        reqReverseGeocoder(pos.lat, pos.lon, (addr) => {
          this.content.addr = addr
        })
      }
    },
    computed: {},
    mounted() {
      this.$nextTick(() => {
       this.mapInfoModalRef = this.$refs.mapInfoModalRef
        this.mapInfoModalRef.styleData.height = 200;
        this.mapInfoModalRef.styleData.width = 233;
      })
    }
  }

</script>
<style lang="less">

</style>
